import React from "react";

const AddPickupIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 17 18"
    fill="none"
  >
    <path
      d="M4.09722 1.49512V3.37012M12.8472 1.49512V3.37012M0.970551 14.6201V5.24262C0.970551 4.74534 1.16809 4.26842 1.51973 3.91679C1.87136 3.56516 2.34827 3.36762 2.84555 3.36762H14.0955C14.5928 3.36762 15.0697 3.56516 15.4214 3.91679C15.773 4.26842 15.9706 4.74534 15.9706 5.24262V14.6185M15.9706 14.6185C15.9706 15.1157 15.773 15.5926 15.4214 15.9443C15.0697 16.2959 14.5928 16.4935 14.0955 16.4935H2.84555C2.34827 16.4935 1.87136 16.2959 1.51973 15.9443C1.16809 15.5926 0.970551 15.1157 0.970551 14.6185V8.36845C0.970551 7.87117 1.16809 7.39426 1.51973 7.04263C1.87136 6.69099 2.34827 6.49345 2.84555 6.49345H14.0955C14.5928 6.49345 15.0697 6.69099 15.4214 7.04263C15.773 7.39426 15.9706 7.87117 15.9706 8.36845V14.6185ZM10.3456 9.61845H12.2205M4.72055 11.4935H8.47055M8.47222 9.61845H8.47638V9.62345H8.47222V9.61845ZM8.47138 13.3685H8.47638V13.3735H8.47138V13.3685ZM6.59638 13.3693H6.60055V13.3743H6.59722V13.3693H6.59638ZM4.72138 13.3693H4.72555V13.3735H4.72055V13.3693H4.72138ZM10.3464 11.4968H10.3505V11.501H10.3464V11.4968ZM10.3464 13.3693H10.3514V13.3743H10.3464V13.3693ZM12.2214 11.496H12.2264V11.5001H12.2222L12.2214 11.496Z"
      stroke="#9c9696ff"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default AddPickupIconSvg;
